import React, { useEffect, useRef, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faDownload, faSync } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import meta from '../../config/meta';
import { env } from '../../config';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Padding from '../layout/Padding.jsx';
import Article from '../blocks/Article.jsx';

const HistoryArticleTitleBox = ({
  className,
  article,
  onGoBack,
  onRefresh,
  onDownload,
  showDownload,
  scrollRef,
}) => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef?.current) {
        setShowBackToTop(scrollRef.current.scrollTop > 300);
      }
    };

    const scrollElement = scrollRef?.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
      return () => scrollElement.removeEventListener('scroll', handleScroll);
    }
    return undefined;
  }, [scrollRef]);

  return (
    <div className={className}>
      <div className="row align-items-center mb-3 g-1">
        <div className="col article-subjects">
          {(article.subjects || []).map((subject, i) => (
            <img key={i} src={`/assets/img/${subject}.svg`} alt={subject} />
          ))}
        </div>
        <div className="col-auto text-center article-material-title">
          <img className="left" src="/assets/img/planet.png" />
          閱讀材料
          <img className="right" src="/assets/img/rocket.png" />
        </div>
        <div className="col article-btn-back d-flex justify-content-end" style={{ gap: '16px' }}>
          <button
            className="btn btn-link d-flex align-items-center"
            onClick={onRefresh}
            title="重新載入文章"
            style={{ gap: '6px' }}
          >
            <FontAwesomeIcon icon={faSync} className="me-2" />
            <span className="d-none d-sm-inline">刷新</span>
          </button>
          {showDownload && (
            <button
              className="btn btn-link d-flex align-items-center"
              onClick={onDownload}
              title="下載文章及題目"
              style={{ gap: '6px' }}
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              <span className="d-none d-sm-inline">下載</span>
            </button>
          )}
          <button
            className="btn btn-link d-flex align-items-center"
            onClick={onGoBack}
          >
            <img src="/assets/img/back.svg" alt="返回" />
            <span className="d-none d-sm-inline">返回</span>
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col text-center">
          <div className="article-title">{article.title || ''}</div>
        </div>
      </div>

      {showBackToTop && (
        <button
          className="btn btn-primary position-fixed d-flex align-items-center justify-content-center"
          style={{
            bottom: '20px',
            right: '20px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            zIndex: 1000,
            backgroundColor: '#FF831E',
            border: 'none',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          }}
          onClick={() => {
            if (scrollRef?.current) {
              scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
          aria-label="回到頂部"
        >
          <FontAwesomeIcon
            icon={faArrowUp}
            style={{ fontSize: '20px', color: 'white' }}
          />
        </button>
      )}
    </div>
  );
};

const PageReadingHistoryArticle = () => {
  const { _id } = useParams();
  const history = useHistory();
  const [res, req] = useHttpStatus();
  const [articleRefreshKey, setArticleRefreshKey] = useState(0);
  const scrollRef = useRef();
  const { pdfOpenDate, pdfCloseDate } = env?.certSetting || {};

  let showDownload = false;
  if (pdfOpenDate && pdfCloseDate) {
    const openDate = moment(pdfOpenDate);
    const closeDate = moment(pdfCloseDate);
    if (openDate.isValid() && closeDate.isValid()) {
      if (openDate.isSameOrBefore(closeDate)) {
        showDownload = moment().isSameOrAfter(openDate) && moment().isSameOrBefore(closeDate);
      } else {
        showDownload = moment().isSameOrAfter(openDate) || moment().isSameOrBefore(closeDate);
      }
    }
  }

  useEffect(() => {
    req({ url: `/api/quiz/articles/${_id}` });
  }, [_id]);

  return (
    <PageHttp res={res}>
      {(article) => {
        meta.set({ title: article && article.title ? article.title : '閱讀材料' });

        return (
          <>
            <header className="mission-header container-fluid p-0 overflow-hidden d-flex position-relative justify-content-center align-items-center -min-vh-30">
              <div className="missions-title-box">閱讀材料</div>
            </header>

            <div className="container-fluid">
              <div className="row">
                <div className="col-12 p-0 shadow-r scrollable" ref={scrollRef}>
                  <Padding className="py-4 article-content">
                    <HistoryArticleTitleBox
                      className="pb-3"
                      article={article}
                      onGoBack={() => history.goBack()}
                      onRefresh={() => setArticleRefreshKey((k) => k + 1)}
                      showDownload={showDownload}
                      onDownload={() => {
                        window.open(`/api/quiz/answers/pdf/article/${_id}`, '_blank');
                      }}
                      scrollRef={scrollRef}
                    />
                    <Article
                      key={`history-article-${articleRefreshKey}`}
                      article={article}
                      hideTags
                      hideTitle
                    />
                  </Padding>
                </div>
              </div>
            </div>
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageReadingHistoryArticle;
